import axios from 'axios';
import { SESSION_TOKEN_STORAGE_KEY } from 'constants/session';

let requesting = false;
const server = 'https://cidadaniaja.appspot.com/';
const timeout = 200000;

export const handleSignin = (e) => new Promise(function (resolve, reject) {
  if (!requesting) {
    requesting = true;
    /*
    let req = "";
    for (let i = 0; i < e.target.length; i++) {
        const element = e.target[i];
        if(element.name) req += `${element.name}=${element.value}&`
    }
    */
    axios.post(`${server}auth/login`, {
      username: 'root',
      password: '123456',
    })
      .then(res => {
        localStorage.setItem('token', res.data.access_token);
        resolve(res.data);
        clearTimeout(time);
      })
      .catch(error => {
        reject(error);
        clearTimeout(time);
      });
    const time = setTimeout(() => { reject('timeout'); }, timeout);
  }
  else {
    reject('Already requesting');
  }
});


export const handleSignout = (e) => new Promise(function (resolve, reject) {
  if (!requesting) {
    requesting = true;
    e.preventDefault();
    axios.post(`${server}/auth/signout`)
      .then(res => {
        resolve(res.data);
        clearTimeout(time);
      })
      .catch(error => {
        reject(error);
        clearTimeout(time);
      });
    const time = setTimeout(() => { reject('timeout'); }, timeout);
  }
  else {
    reject('Already requesting');
  }
});

export const getProducts = () => new Promise(function (resolve, reject) {
  //   if(!requesting) {
  //       requesting = true;
  const instance = axios.create({
    baseURL: `${server}`,
    headers: { 'Authorization': `Bearer ${localStorage.getItem(SESSION_TOKEN_STORAGE_KEY)}` },
  });
  //        axios.get(`${server}product`)

  instance.get('/product')
    .then(res => {
      resolve(res.data.result);
      clearTimeout(time);
    })
    .catch(error => {
      reject(error);
      clearTimeout(time);
    });
  const time = setTimeout(() => { reject('timeout'); }, timeout);
  //    }
  //    else {
  //        reject('Already requesting');
  //    }
});

export const getProductByTitle = title => new Promise(function (resolve, reject) {
  if (!requesting) {
    requesting = true;
    axios.get(`${server}product/?title=${title}`)
      .then(res => {
        resolve(res.data);
        clearTimeout(time);
      })
      .catch(error => {
        reject(error);
        clearTimeout(time);
      });
    const time = setTimeout(() => { reject('timeout'); }, timeout)
  }
  else {
    reject('Already requesting');
  }
});

export const getContractTest = (id) => new Promise(function (resolve, reject) {
  if (!requesting) {
    requesting = true;
    if (!Boolean(id)) reject('Usuário não definido.');
    let address = `contract/id/?id=${id}`;
    axios.get(`${server}${address}`)
      .then(response => {
        resolve(response.data.data.contract);
      })
      .catch(response => {
        reject(response);
      });
  }
  else {
    reject('Already requesting.');
  }
});

export const getContractTestPdf = (id) => new Promise(function (resolve, reject) {
  if (!requesting) {
    requesting = true;
    if (!Boolean(id)) reject('Usuário não definido.');
    let address = `contract/checklist/?email=a`;
    axios.get(`${server}${address}`)
      .then(response => {
        resolve(response);
      })
      .catch(response => {
        reject(response);
      });
  }
  else {
    reject('Already requesting.');
  }
});

export const postForm = (object, type) => new Promise(function (resolve, reject) {
  if (!requesting) {
    requesting = true;
    let address = `form/${type === 'vendor' ? 'vendor' : type === 'client' ? 'client' : ''}`;
    axios.post(`${server}/${address}`, {
      ...object
    })
      .then(response => {
        console.log(response);
      })
      .catch(response => {
        console.log(response);
      });
  }
  else {
    reject('Already requesting');
  }
});
